<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container med-container px-lg-0">
        <span>Producto</span>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container med-container description-section" id="product-description">
      <div class="row">

        <div class="col-lg-6 col-gallery" v-if='!icecat'>
          <swiper :options="galleryOptions">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">
                  <img :src="row" class="w-100">
                  <!-- <v-zoom :img="row" :width="'100%'"></v-zoom> -->
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

          <!-- <div class="box-video">
            <iframe src="https://www.youtube.com/embed/yQ_vtTTukq4?si=Aad3F_WR6QZEyEtf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div> -->
        </div>

        <b-form class="mt-3 mt-lg-0 col-lg-6 col-description" @submit.prevent="addCart()">
          <h1 class="mb-2 name">{{ product.name }}</h1>
          <!-- <h4 class="price discount"><span>$ {{ product.price }}</span></h4> -->
          <!-- <h4 class="price f-w-700 old-price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.oldPrice) }}</h4> -->
          <h4 class="price f-w-700" v-if="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price) }}</h4>
          <div class="b-short-description">
            <!-- <h6><span class="label">Potecia</span> <span class="txt-1">6 HP a 24,000 RPM’s</span></h6>
            <h6><span class="label">Area util</span> (X)1220 x (Y) 2440 X (Z) 200 mm</h6>
            <h6><span class="label">Velocidad de avance</span> 35,000 mm/min</h6>
            <h6><span class="label">Precisión +/-</span> 0.15 mm</h6> -->

            <div class="descr" v-html="product.description"></div>
          </div>

          <!-- <h6 class="mt-3 subtitle">Compartir</h6>
          <div class="col-12 mt-1 col-extra col-networks" id="col-extra">
            <div class="row">
              <div class="col b-print">
                <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
              </div>

              <div class="col px-0 b-sharing">
                <ShareNetwork
                  v-for="(network, pdInx) in networks"
                  :network="network.network"
                  :key="network.network"
                  :style="{backgroundColor: network.color}"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser">
                  <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                </ShareNetwork>
              </div>
            </div>
          </div> -->

          <div class="mt-3 mb-3 accordion-no-border" role="tablist" v-if="product.package == false">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-0>PRESENTACIONES <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-0" accordion="my-accordion" role="tabpanel" visible>
                <b-card-body>
                  <div class="txt-description">
                    <div class="box-presentation">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                          class="radio-boxes"
                          v-model="form.products_models_id"
                          :aria-describedby="ariaDescribedby"
                          name="radio-sub-component" required v-for="(mond,indx) in product.models" :key="indx">
                          <b-form-radio :value="mond.id">{{ mond.name }}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <div class="mt-3 mb-3 accordion-no-border" role="tablist" v-if="product.package == true">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-components>PRODUCTOS INCLUIDOS <i class="icon"></i></h6>
              </b-card-header>
              <b-collapse id="accordion-components" accordion="my-accordion" role="tabpanel" visible>
                <b-card-body>
                  <div class="txt-description">
                    <div class="box-presentation">
                      <div class="components-grid" v-if="product.components && product.components.length > 0">
                        <a :href="'/#/producto/'+$root._converToURL(component.name, component.id)" target="_blank" class="component-item" v-for="(component, index) in product.components" :key="component.id">
                          <div class="component-image">
                            <img :src="component.imageUrl" :alt="component.name" class="img-fluid">
                          </div>
                          <div class="component-info">
                            <h6 class="component-name">{{ component.name }}</h6>
                          </div>
                        </a>
                      </div>
                      
                        <div class="no-components" v-else>
                          <p class="text-muted">No hay productos incluidos en este paquete.</p>
                        </div>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <div class="mt-3 mb-3 accordion-no-border" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-1>INFORMACIÓN NUTRIMENTAL <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="txt-description">
                    <p>
                      Conoce los beneficios y propiedades de nuestros productos.
                    </p>
                    <div class="box-features" v-html="product.description"></div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-3>PREGUNTAS FRECUENTES <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="d-block py-1">
                      <div class="d-block b-faqs" v-html="product.faqs"></div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-4>A TRATAR <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                    <div class="txt-description">
                        <div class="box-features" v-html="product.to_treat"></div>
                    </div>
                    </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-5>FORMULAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                    <div class="txt-description">
                        <div class="box-features" v-html="product.formulas"></div>
                    </div>
                    </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-6>DESCARGAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="row pb-1">
                      <div class="col-lg-6 col-download py-2">
                        <a class="w-100 btn btn-outline" :href="product.documentUrl" target="_blank">Documento</a>
                      </div>


                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-5>VIDEO <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="box-video">
                      <iframe src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->
          <!--  -->

          <!-- <h4 class="pt-2 price f-w-700">Desde $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} más IVA</h4> -->

          <div class="row mt-4 row-quantity-button">
            <div class="col-lg col-quantity">
              <h6 class="subtitle" v-if="product.stock">Cantidad</h6>
              <div class="row no-gutters pt-1 box-options" v-if="product.stock">
                <div class="col col-short">
                  <b-form-input v-model="form.quantity" type="number" class="text-center" required></b-form-input>
                </div>
              </div>
            </div>

            <div class="col-lg pl-lg-0 mt-3 mt-lg-2 col-btn-send">
              <b-button type="submit" class="w-100 btn-submit c1"><i class="fa-solid fa-cart-shopping"></i> COMPRAR</b-button>
            </div>

            <!-- <div class="col-12 col-btn-send mb-3">
              <b-button type="submit" class="w-100 btn btn-submit c2">DESDE $ <span class="f-w-700">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span> MÁS IVA</b-button>
            </div> -->

            <!-- <div class="col-12 col-btn-send">
              <router-link class="w-100 btn btn-submit c1" to="/contacto">SOLICITAR COTIZACIÓN</router-link>
            </div> -->
          </div>

          <div class="d-block mt-4 mb-2" v-if="product.pdf">
            <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">PDF <i class="fa fa-file-pdf-o"></i></a>
          </div>

          <div class="col-12 my-2">
            <div class="row">
              <div class="col-sm-6 my-2 px-0 pr-sm-3" v-if="product.stock">
                <!-- <b-button type="submit" class="w-100 btn-submit">AGREGAR AL CARRITO <i class="fa-solid fa-cart-shopping"></i></b-button> -->
              </div>

              <div class="col-sm-6 my-2 px-0 pl-sm-3">
                <!-- <router-link class="w-100 btn btn-submit btn-contact" :to="{ name: 'contacto', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link> -->
              </div>
            </div>
          </div>

          <!-- <h6 class="subtitle">Inventarios</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <table id="stocktable">
                <tr>
                  <th>Almacen</th>
                  <th>Stock</th>
                </tr>
                <tr v-for="(st,indx) in product.stocks" :key="indx">
                  <td>{{st.warehouse}}</td>
                  <td>{{st.stock}}</td>
                </tr>
            </table>
          </div> -->
        </b-form>

        <!-- <div class="col-12 mb-2">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-comment-form">
          <div class="col-12 col-comments">
            <b-form class="box-comment" @submit="addComment">
              <h5 class="subt">Califica este producto</h5>

              <div class="box-stars">
                <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
              </div>

              <div class="box-input">
                <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                <p class="mt-2 text-right">
                  <b-button type="submit" class="btn-co">Comentar</b-button>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="col-lg-6 mt-3 col-all-comments">
          <div class="wr-comments" v-if="comments.length">
            <div class="row">

              <div class="col-12 col-total-comments" v-if="avg > 0">
                <div class="box"><small>TOTAL:</small> {{ Math.ceil(avg) }}</div>
              </div>

              <div class="col-12 col-comments">
                <div class="row">
                  <div class="col-lg-6 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                    <div class="box">
                      <div class="box-stars">
                        <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                      </div>

                      <div class="box-comment">{{ item.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 mx-auto col-extrainfo" v-if="icecat">
            <div id="Container5"></div>
            <div id="Container7"></div>
            <div id="Container11"></div>
        </div> -->

      </div>

    </section>
     <!--
    <section class="container med-container related-products-section" id="related-products">
      <div class="row">
        <div class="col-12 px-2 col-s-title">
          <h2 class="text-center title-s1">PRODUCTOS RELACIONADOS</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

     <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1" :options="productsOption">
            <swiper-slide v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <div class="col-12 px-0 sample-product shad-prod">
                <a class="outlined-box">
                  <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                  <div class="box-image">
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                      <img src="public/images/pages/products/product.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ product.sku }}</h6>
                    <h6 class="name">{{ product.name }}</h6>
                  </div>

                  <cart-component :product="product"></cart-component>
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>
    -->
    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
      </div>
    </sweet-modal>

  </div>
</template>

<script>
import vZoom from 'vue-zoom'; // https://www.npmjs.com/package/vue-zoom
export default {
  components: {vZoom},

  data() {
    return {
      id: null,

      form: {
        quantity: 1,
        products_models_id:null,
      },

      gallery: [  ],

      product: {},
      category: [],
      sizes: [],
      size: [],
      stock: 0,
      avg: 0,
      favorite: false,
      icecat: false,

      products: [],

      // == Sharing ==
      sharing: {
        url: 'https://ferosdinaflex.online/#/producto/',
        title: 'Feros',
        description: 'Esto es un ejemplo de descripción',
        quote: 'Esto es el Quote',
        hashtags: 'this,isthe,hashtag',
        twitterUser: 'twitter'
      },

      networks: [
        { network: 'twitter', name: 'Twitter', icon: 'fa-brands fa-x-twitter' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f' },
        { network: 'email', name: 'Email', icon: 'fas fa-envelope' },
        { network: 'whatsapp', name: 'WhatsApp', icon: 'fab fa-whatsapp' },
      ],
      // == ==

      colors: [],

      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 4,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: 0,
            slidesPerView: 4
          },
          992: {
            spaceBetween: 0,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },
      price:null,
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      //this.id = this.$route.params.id;
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getProduct();
    },
    'form.products_models_id':function(){
        this.product.models.forEach(mod => {
            if(mod.id == this.form.products_models_id){
                this.price = mod.price;
            }
        });
    }
  },

  methods:{
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    copyLink(value) {
      navigator.clipboard.writeText(value);
      // alert('Link copiado');
      this.toast('Pago seguro ', 'Link copiado correctamente', 'success');
    },

    getComments(id){
      axios.get(tools.url('/api/comments/'+id)).then((response)=>{
        this.comments = response.data.comments;
        this.avg = response.data.avg;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addComment: function(){
        axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
            this.comment.stars = null;
            this.comment.body = '';
            this.getComments(this.id);
        }).catch((error) => {
            alert("Error al agregar comentario");
            console.log(error);
        })
    },



    getProduct(){
      axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = [];
        this.gallery = [];
        this.product = response.data;
        this.category = response.data.category;
        this.gallery = response.data.gallery;

        if(this.product.stock > 0){
          this.form.quantity = 1;
        }

        if(this.product.package == 1){
          this.price = this.product.price;
        }
        else{
          if(this.product.models) { // Seleccionar por default una presentación
            setTimeout(()=> {
              this.form.products_models_id = this.product.models[0].id;
            }, 700)
          }
        }
        //this.getRelated(this.product.id);
        //this.getComments(this.product.id);
      }).catch((error)=>{
        console.log(error);
      });
    },

    addCart(){
      if(this.product.package == 0){
        if (!this.form.products_models_id) {
            this.modal.msg = 'Debes seleccionar una presentación';
            this.modal.icon = 'warning';
            this.$refs.modal.open();
            return;
        }
      }
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id && cart[i].products_models_id == this.form.products_models_id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.stock ? suma : this.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity,products_models_id:this.form.products_models_id });
            }
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity,products_models_id:this.form.products_models_id });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }

    },

    getRelated(id){
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/favorite'),{ product_id: this.id }).then((response)=>{
                if(response.data == 'true'){
                    this.favorite = true;
                }else{
                    this.favorite = false;
                }
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    addFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/addFavorite'),{product_id: this.id }).then((response)=>{
                this.favorite = response.data.favorite;
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    favoritesCount: function(){
        if(this.$root.user.id){
            axios.get(tools.url('/api/favoritesCount')).then((response)=>{
                this.$root.favoriteCount = response.data;
            }).catch((error)=>{
                console.log(error);
            })
        }
    }

  },

  mounted(){
    this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();

    /*if(this.$root.logged == true){
        this.getFavorite();
    }*/
  }
}
</script>
<style>
#stocktable table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#stocktable td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#stocktable th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  background-color: #dddddd;
}

/* Estilos para los componentes del paquete */
.components-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 15px;
}

.component-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  text-decoration: none;
  color: inherit;
}

.component-item:hover {
  border-color: #ba2621;
  box-shadow: 0 2px 8px rgba(186, 38, 33, 0.15);
  transform: translateY(-2px);
  text-decoration: none;
  color: inherit;
}

.component-image {
  flex-shrink: 0;
  margin-right: 15px;
}

.component-image img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.component-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 60px;
}

.component-name {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
}



.no-components {
  text-align: center;
  padding: 30px;
  color: #6c757d;
}

/* Responsive design */
@media (max-width: 768px) {
  .components-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .component-item {
    padding: 12px;
  }
  
  .component-image img {
    width: 50px;
    height: 50px;
  }
  
  .component-name {
    font-size: 13px;
  }
}
</style>
